import { useQuery } from '@tanstack/react-query';
import type { EntityType } from '@/lib/constants/entity-types';
import { listTeamMembers } from '../api/team.api';
import { teamKeys } from './team.keys';

/**
 * Load the entity's team members with effective permission flags (MYN-43).
 * Disabled until an entity id (and its type, to pick the right API resource)
 * is known. `refetchInterval` lets the Team Access page keep the roster in
 * step with its invites poll, so an accepted invite shows up as a member.
 */
export function useTeamMembers(
  entityId: string | undefined,
  entityType: EntityType | undefined,
  refetchInterval: number | false = false,
) {
  return useQuery({
    queryKey: teamKeys.members(entityId ?? '', entityType),
    queryFn: () => listTeamMembers(entityId as string, entityType as EntityType),
    enabled: Boolean(entityId) && Boolean(entityType),
    refetchInterval,
  });
}
